var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MdImg",class:_vm.imgClass},[_c('div',[_c('a',{style:(_vm.aspectStyle)},[_c('span',{style:(_vm.imgStyle)})])])])}
var staticRenderFns = []

export { render, staticRenderFns }